import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

export default class extends Controller {
  static targets = [
    "row",
    "documentsFrame",
    "sinistersFrame",
    "ledgerFrame",
    "documentsSkeleton",
    "sinistersSkeleton",
    "ledgerSkeleton"
  ]
  static values = {
    documentsUrl: String,
    sinistersUrl: String,
    ledgerUrl: String,
    selectedId: Number
  }

  connect() {
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
    this.currentPolicyId =
      this.hasSelectedIdValue && this.selectedIdValue
        ? String(this.selectedIdValue)
        : null
    this.highlightSelectedRow()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  onFrameLoad = () => {
    this.highlightSelectedRow()
  }

  selectContractFromTable(event) {
    const row = event.currentTarget
    if (event.target.closest("a, button, form, input, label, .dropdown")) return

    this.closeOpenDropdowns()

    const policyId = row.dataset.policyId
    if (!policyId) return

    event.preventDefault()
    this.selectPolicy(policyId)
  }

  closeOpenDropdowns() {
    this.element.querySelectorAll(".dropdown-menu.show").forEach((menu) => {
      const toggle = menu.closest(".dropdown")?.querySelector('[data-bs-toggle="dropdown"]')
      if (!toggle) return

      Dropdown.getInstance(toggle)?.hide()
    })
  }

  highlightRow(policyId) {
    this.rowElements.forEach((row) => {
      row.classList.toggle(
        "subscriber-dashboard__contract-row--selected",
        row.dataset.policyId === policyId
      )
    })
  }

  // Le squelette est peint AVANT de changer `src` : la frame réagit au clic, pas à la
  // réponse. Sans lui, l'aperçu du contrat précédent restait affiché — ou l'invitation
  // « Sélectionnez un contrat » — pendant tout l'aller-retour.
  refreshPanel(frame, baseUrl, policyId, skeleton) {
    if (!frame || !baseUrl) return

    const url = new URL(baseUrl, window.location.origin)
    url.searchParams.set("insurance_policy_id", policyId)
    const src = url.toString()

    // Même contrat : Turbo ne recharge pas une frame dont `src` ne change pas, un squelette
    // peint ici ne serait donc jamais remplacé.
    if (frame.src && new URL(frame.src, window.location.origin).toString() === src) return

    if (skeleton) frame.replaceChildren(skeleton.content.cloneNode(true))
    frame.src = src
  }

  selectPolicy(policyId) {
    this.currentPolicyId = String(policyId)
    this.highlightRow(this.currentPolicyId)
    if (this.hasDocumentsFrameTarget) {
      this.refreshPanel(this.documentsFrameTarget, this.documentsUrlValue, policyId, this.skeleton("documents"))
    }
    if (this.hasSinistersFrameTarget) {
      this.refreshPanel(this.sinistersFrameTarget, this.sinistersUrlValue, policyId, this.skeleton("sinisters"))
    }
    if (this.hasLedgerFrameTarget) {
      this.refreshPanel(this.ledgerFrameTarget, this.ledgerUrlValue, policyId, this.skeleton("ledger"))
    }
  }

  skeleton(name) {
    const target = `${name}SkeletonTarget`
    return this[`has${name.charAt(0).toUpperCase()}${name.slice(1)}SkeletonTarget`] ? this[target] : null
  }

  highlightSelectedRow() {
    if (!this.currentPolicyId) return

    this.highlightRow(this.currentPolicyId)
  }

  get rowElements() {
    if (this.hasRowTarget) return this.rowTargets

    return this.element.querySelectorAll("[data-subscriber-dashboard-target='row']")
  }
}
